import type { TextStyleValue } from '@elfsight/configurator-contracts';
import type { CornerRadiusType } from '../../../types';

export interface PopupStyles {
  paddingVertical: number;
  paddingHorizontal: number;
  margin: number;
  fullscreen: boolean;
  fieldHeadingFontStyle: TextStyleValue;
  cornerRadius?: CornerRadiusType;
}

export const defaultFormPopupStyles: PopupStyles = {
  margin: 40,
  paddingHorizontal: 60,
  paddingVertical: 60,
  fieldHeadingFontStyle: {
    fontSize: 24,
    fontWeight: 'bold',
    lineHeight: '30px'
  },
  fullscreen: false
};

export const mediumFormPopupStyles: PopupStyles = {
  ...defaultFormPopupStyles,
  paddingHorizontal: 40,
  paddingVertical: 40
};

export const smallFormPopupStyles: PopupStyles = {
  ...defaultFormPopupStyles,
  margin: 0,
  paddingHorizontal: 20,
  paddingVertical: 48,
  fullscreen: true,
  cornerRadius: 'square',
  fieldHeadingFontStyle: {
    fontSize: 22,
    fontWeight: 'bold',
    lineHeight: '28px'
  }
};
